import { render, staticRenderFns } from "./RegPartner.vue?vue&type=template&id=035be85a"
import script from "./RegPartner.vue?vue&type=script&lang=js"
export * from "./RegPartner.vue?vue&type=script&lang=js"
import style0 from "./RegPartner.vue?vue&type=style&index=0&id=035be85a&prod&lang=less&Scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports